// Module
var code = "<p> <label>detail</label> <input type=\"range\" min=\"0\" max=\"10\" step=\"1\" oninput=\"sphere.p.detail.set(event.target.value)\"> </p>";
// Exports
export default code;